import React, { useContext } from 'react';
import './ProductDisplay.css';
import star_icon from '../assets/star_icon.png';
import star_dull_icon from '../assets/star_dull_icon.png';
import { ShopContext } from '../../context/ShopContext';

function ProductDisplay(props) {
    const { product } = props;
    const {addToCart}=useContext(ShopContext);
    return (
        <div className="productdisplay">
            <div className="productdisplay-left">
                <div className="productdisplay-img-list">
                    <img src={product.image} alt="" />
                    <img src={product.image} alt="" />
                    <img src={product.image} alt="" />
                    <img src={product.image} alt="" />
                </div>
                <div className="productdisplay-img">
                    <img src={product.image} alt="" className="productdisplay-main-img" />
                </div>
            </div>
            <div className="productdisplay-right">
                <h1>{product.name}</h1>
                <div className="productdisplay-right-stars">
                    <img src={star_icon} alt="" />
                    <img src={star_icon} alt="" />
                    <img src={star_icon} alt="" />
                    <img src={star_icon} alt="" />
                    <img src={star_icon} alt="" />
                    <img src={star_dull_icon} alt="" />
                    <p>{22}</p>
                </div>
                <div className="productdisplay-right-prices">
                    <div className="productdisplay-right-price-old">&#x20B9;{product.old_price}</div>
                    <div className="productdisplay-right-price-new">&#x20B9;{product.new_price}</div>
                </div>
                <div className="productdisplay-right-description">
                    A lightweight,usually knitted,pull over shirt,close-fittinng and Lorem ipsum dolor sit amet consectetur adipisicing elit. Iure alias eum quia cumque ratione quae corrupti porro veritatis eius! Harum dolorem tenetur numquam obcaecati. Cum omnis hic dignissimos fugiat porro.
                    Sit amet modi ipsum placeat minima molestiae perferendis, voluptates sint commodi harum 
                </div>
                <div className="productdisplay-right-size">
                    <h1>Select Size</h1>
                    <div className="productdisplay-right-sizes">
                        <div>S</div>
                        <div>M</div>
                        <div>L</div>
                        <div>XL</div>
                        <div>XXL</div>
                    </div>
                </div>
                <button onClick={()=>{addToCart(product.id)}}>ADD TO CART</button>
                <p className="productdisplay-right-category"><span>Category:</span>Women,T-Shirt,Crop Top</p>
                <p className="productdisplay-right-category"><span>Tags:</span>Modern,Latest</p>
            </div>
        </div>
    )
}
export default ProductDisplay;
